import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 出款订单审核列表
export const getWithdrawList = (params: any) =>
  request({
    url: '/manage/withdraw/review/task',
    method: 'get',
    params
  })

// 出款订单审核详情
export const getWithdrawInfo = (params: any) =>
  request({
    url: '/manage/withdraw/review/task/' + params.ordernumber,
    method: 'get',
    params
  })

// 发起单笔代付接口
export const payforOne = (data: any) =>
  request({
    url: '/manage/payfor-one',
    method: 'post',
    data
  })

// 发起批量代付接口
export const payforMany = (data: any) =>
  request({
    url: '/manage/payfor-many',
    method: 'post',
    data
  })

// 驳回代付接口
export const rejectPay = (data: any) =>
  request({
    url: '/manage/withdraw-order/' + data.ordernumber + '/regret',
    method: 'put',
    data
  })

// 修改订单状态
export const setOrderStatus = (data: any) =>
  request({
    url: '/manage/withdraw/review/task/' + data.ordernumber + '/change-status',
    method: 'put',
    data
  })

// 导出
export const tableExport = (data: any) =>
  request({
    url: '/manage/withdraw/review/task/export' + objToUrlParams(data),
    method: 'post'
  })

// 代付列表
export const getPaidList = (params: any) =>
  request({
    url: '/manage/order/' + params.ordernumber + '/withdraw-info',
    method: 'get'
  })

// 修改代付详情状态
export const setPaidStatus = (data: any) =>
  request({
    url: '/manage/withdraw-order/' + data.ordernumber + '/change-status',
    method: 'put',
    data
  })

// 查询代付详情
export const getPaidInfo = (data: any) =>
  request({
    url: '/manage/withdraw-order/' + data.ordernumber + '/query',
    method: 'put'
  })

//修改成功订单状态
export const setSuccessStatus = (data: any) =>
  request({
    url:
      '/manage/success-withdraw-review-task/' +
      data.ordernumber +
      '/change-status',
    method: 'put',
    data
  })

// 批量修改订单状态
export const modifyOrderStatusBulk = (data: any) =>
  request({
    url: '/manage/many-withdraw/review/task/change/status',
    method: 'put',
    data
  })

// 批量修改冻结订单状态
export const batchUnfreezeOrder = (data: any) =>
  request({
    url: '/manage/batch-unfreeze-order',
    method: 'put',
    data
  })

// 出款订单统计
export const paymentOrderStatistics = (params: any) =>
  request({
    url: '/manage/withdraw-order-statistics',
    method: 'get',
    params
  })

// 一键代付
export const openClickPayfor = (data: any) =>
  request({
    url: '/manage/one-click-payfor',
    method: 'post',
    data
  })

//  One-Click Change
export const setOneClickChange = (data: any) =>
  request({
    url: `/manage/one-click-change`,
    method: 'post',
    data
  })

//  One-Click Unfreeze
// export const setOneClickUnfreeze = (params: any, data: any) =>
//   request({
//     url: `/manage/one-click-unfreeze` + objToUrlParams(params),
//     method: 'post',
//     data
//   })
export const setOneClickUnfreeze = (data: any) =>
  request({
    url: `/manage/one-click-unfreeze`,
    method: 'post',
    data
  })
